<template>
  <button :class="btnClasses" :style="btnStyles" @click="handleClick">
    {{ btnContent }} <i :class="iconClasses"></i>
  </button>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    activeContent: {
      type: String,
      required: false,
      default: 'Added',
    },
    inactiveContent: {
      type: String,
      required: false,
      default: 'Add',
    },
    activeColor: {
      type: String,
      required: false,
    },
    inactiveColor: {
      type: String,
      required: false,
    },
  },

  computed: {
    btnClasses () {
      return {
        btn: true,
        'selection-btn': true,
      };
    },

    btnStyles () {
      return this.active ? {
        backgroundColor: this.activeColor ?? '#82df6b',
        color: '#fff',
      } : {
        backgroundColor: this.inactiveColor ?? '#fff',
        color: '#303030',
      };
    },

    iconClasses () {
      return {
        fas: true,
        'ml-2': true,
        'fa-check': this.active,
        'fa-plus': !this.active,
      };
    },

    btnContent () {
      return this.active ? this.activeContent : this.inactiveContent;
    },
  },

  methods: {
    handleClick () {
      this.$emit('change');
    },
  },
};
</script>

<style lang="scss" scoped>
.selection-btn {
  border-radius: 6px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  padding: 6px 8px 5px 8px !important;

}
</style>
